// extracted by mini-css-extract-plugin
export var arrows = "_83-6";
export var decrementer = "_83-a";
export var disabled = "_83-4";
export var error = "_83-1";
export var hiddenText = "_83-b";
export var incrementer = "_83-9";
export var input = "_83-8";
export var inputWrapper = "_83-0";
export var leadingIcon = "_83-c";
export var readonly = "_83-3";
export var regular = "_83-7";
export var small = "_83-5";
export var warning = "_83-2";